<template>
  <div class="menu-item" @click="toggleMenu" @mouseleave="closeMenu">
    <i class="fas fa-user-circle custom-arrow-icon" aria-hidden="true"></i>
    <transition name="fade" appear>
      <!-- MODIF: Adicionado ref ao submenu -->
      <div class="sub-menu" v-if="isOpen" ref="submenu">
        <!-- MODIF: Alterado para router-link custom para que o div inteiro seja clicável -->
        <router-link to="/acesso/alterarSenhaUsuario" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="alterarSenha">
            Alterar Senha
          </div>
        </router-link>
        <router-link to="/acesso/pedToken" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="token">
            Obter Token do Usuário
          </div>
        </router-link>
        <!-- MODIF: Para o item "Sair", removemos o <a> e usamos um div com click para logout -->
        <div class="menu-item nav-item nav-link" id="sair" @click="logout">
          <span>Sair</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
import { useLoginStore } from "../stores/LoginStore.js";
export default {
  name: "services",
  props: ["title"],
  data() {
    return {
      isOpen: false,
    };
  },
  setup() {
    const loginStore = useLoginStore();
    return {
      loginStore,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.adjustSubmenuPosition();
        });
      }
    },
    closeMenu() {
      this.isOpen = false;
    },
    adjustSubmenuPosition() {
      const submenu = this.$refs.submenu;
      if (submenu) {
        const rect = submenu.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
          submenu.style.left = "auto";
          submenu.style.right = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else if (rect.left < 0) {
          submenu.style.left = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else {
          submenu.style.left = "50%";
          submenu.style.right = "auto";
          submenu.style.transform = "translateX(-50%)";
        }
      }
    },
    // MODIF: Método para realizar logout
    logout() {
      this.loginStore.logout();
    },
  },
};
</script>

<style>
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}
nav .menu-item .sub-menu {
  position: absolute;
  background-color: #3276b1; /* MODIF: Fundo opaco garantido */
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  border-radius: 0px 0px 16px 16px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.sub-menu {
  cursor: pointer;
}
</style>

